import Vue from "vue";
import { store } from '@/observable/store'
import { CacheModule } from '@/utils/commonUtils'

export const
    InsurStore = Vue.observable({
        insurance: {}, //保险信息
        pay_period:'', //缴费方式
        pay_action:'', // 支付方式
        moneyStr:'', //展示的价格
        amount:'', //实付金额
        relation:'', // 关系
        social_security:0,  //0-无社保, 1-有社保
        cookLast:0
    });

export const
    InsurMutations = {
        // 保险信息存储 
        insurance(parme) {
            const newData = parme;
            newData.amount = newData.amount/100;
            newData.payable_amount = newData.payable_amount/100;
            newData.stage_info.amount?  newData.stage_info.amount= newData.stage_info.amount/100:'';
            newData.stage_info.first_amount?  newData.stage_info.first_amount = newData.stage_info.first_amount/100:'';
            newData.cache = JSON.parse(newData.cache)
            InsurStore.insurance = newData
            this.setMoney()

        },
        // 缴费方式切换
        setPay_period(data){
            InsurStore.pay_period = data
            this.setMoney(data)
        },
        // 缴费方式切换 存储下单时要传入的支付方式对应的key
        setPay_action(data){
            InsurStore.pay_action = data
        },
        // 缴费方式切换 展示内容切换
        setMoney(data = 'year'){
            if(data == 'year'){ //年缴 价格展示固定价格
                InsurStore.moneyStr = `<span class="ft14"> ￥ </span><span class="ftwh500">${InsurStore.insurance.amount}</span`;
                InsurStore.amount = InsurStore.insurance.amount
            }else if(data == 'month'){ //月缴 价格展示首月价格
                InsurStore.moneyStr = `<span class="ft14">首月 ￥ </span><span class="ftwh500">${InsurStore.insurance.stage_info.first_amount}</span>`
                InsurStore.amount = InsurStore.insurance.stage_info.first_amount 
            }

        },
        // 为谁购买 与本人关系 用于下单时传给后端
        setRelation(str){
            InsurStore.relation = str
        },
        // 获取投保人信息 
        getmyInfo(){
             
             let name = InsurStore.insurance.last_identity_info.applicant_name
             let idcard = InsurStore.insurance.last_identity_info.applicant_idcard
             let phone = store.phone
                // 点击客服跳出时会存储在浏览器 投被保人信息 优先展示缓存 
             const info = CacheModule.getSessionStorage('cook_last_info')
             if(info && info.relation){
                 name = info.applicant.name
                 idcard = info.applicant.idcard
                 phone = info.applicant.phone
             }
            return { 'name':name, 'idcard': idcard, 'phone':phone }
        },
        // 获取被保人信息 
        getotherInfo(){
            let name = InsurStore.insurance.last_identity_info.insure_name
            let idcard = InsurStore.insurance.last_identity_info.insure_idcard
            let phone = InsurStore.insurance.last_identity_info.insure_phone
            let relation = InsurStore.insurance.last_identity_info.relation
               // 点击客服跳出时会存储在浏览器 投被保人信息 优先展示缓存 
            const info = CacheModule.getSessionStorage('cook_last_info')
            if(info && info.relation){
                name = info.insure.name
                idcard = info.insure.idcard
                phone = info.insure.phone
                relation = info.relation
            }
           return { data :{'name':name, 'idcard': idcard, 'phone':phone},'relation':relation }
       }


    };